<template>
  <v-card flat>
    <v-form ref="form" v-model="valid" lazy-validation>
      <h1>{{ $t('labels.instructor-email') }}</h1>
      <p>{{ $t('application.email.instructor-info') }}</p>
      <!-- Form with email input field -->
      <v-text-field
        ref="email"
        class="mb-n5 mt-5"
        outlined
        v-model="application.email"
        :placeholder="$t('application.email.e-postadress')"
        :rules="[rules.required, rules.email]"
      ></v-text-field>
    </v-form>
    <!-- Go to a next  step-->
    <NextButton
      :isDisabled="!valid || (application && application.email == null)"
      @click="nextStep"
    >{{ $t('tour.next') }}</NextButton>
    <!-- Go to a previous  step-->
    <BottomNav @clicked="$emit('goToStep', '-1')" />
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapActions, mapGetters} from 'vuex'
import pick from 'lodash/pick'
import {RulesMixin} from '@/components/mixins'
import NextButton from '@/components/Common/NextButton'
import BottomNav from '@/components/Application/BottomNav'

// @group Application-Company
// ApplicationEmail component
export default {
  name: 'ApplicationEmail',

  mixins: [RulesMixin],

  components: {
    NextButton,
    BottomNav
  },

  data: () => ({
    application: null,
    fields: ['id', 'email'],
    valid: false
  }),

  created() {
    /**
     * @vuese
     * Used to reset form validation and call  initApplication function
     */
    if (this.$refs.form && this.$refs.form !== undefined) {
      this.$refs.form.resetValidation()
    }
    this.initApplication()
  },

  watch: {
    /**
     * @vuese
     * Used to watch the selectedApplication , reset validation  and call initApplication function
     */
    selectedApplication: {
      handler: function () {
        if (this.$refs.form && this.$refs.form !== undefined) {
          this.$refs.form.resetValidation()
        }
        this.initApplication()
      },
      deep: true
    },
    /**
     * @vuese
     * Used to watch the currentStep , reset validation and call initApplication
     * @arg called with no argument
     */
    currentStep: {
      handler: function () {
        if (this.$refs.form && this.$refs.form !== undefined) {
          this.$refs.form.resetValidation()
        }
        this.initApplication()
      },
      deep: true
    }
  },

  computed: {
    ...mapGetters('application', ['currentStep', 'selectedApplication']),
    ...mapGetters('currentuser', ['currentUser'])
  },

  methods: {
    ...mapActions('application', ['setSelectedApplication', 'updateSelectedApplication']),
    /**
     * @vuese
     * Used to Initialize application with either selected email or empty email field
     */
    initApplication() {
      if (this.selectedApplication && this.selectedApplication.id) {
        this.application = pick(this.selectedApplication, this.fields)
      } else {
        this.application = Object.fromEntries(
          this.fields.map(f => {
            return [f, null]
          })
        )
      }
      this.application.step = this.currentStep
    },
    /**
     * @vuese
     * Used to go to the next step if form is valid and update the application with email field
     * @arg The argument is an integer value application  id and params are the selected fields
     */
    async nextStep() {
      if (!this.$refs.form.validate()) {
        this.$events.fire('showError', this.$t('errors.form-validation'))
        return
      }

      if (this.application.id && this.application.id > 0) {
        API.updateApplication(this.application.id, {data: this.application})
          .then(() => {
            /**
             * @vuese
             * Used to update application in vuex store
             * @arg The params are current fields of the application
             */
            this.updateSelectedApplication(this.application)
            // Fire +1
            // @arg The argument is a integer representing (in which step to go)
            this.$emit('goToStep', '+1')
          })
          .catch(error => {
            this.$events.fire('showError', this.$t('errors.save-failure'))
          })
      }
    }
  }
}
</script>

<style scoped>
</style>
